import { useStoresGateway } from "@common/hooks/useStoresGateway";
import { useQuery } from "react-query";
import { gql } from "graphql-request";

export function useIndustry() {
  const { request } = useStoresGateway();

  return useQuery("groupedIndustries:", async () => {
    const { groupedIndustries } = await request(
      gql`query { 
        groupedIndustries {
          code
        }
      }`
    )

    return groupedIndustries;
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
}